import React from 'react';
import { Flex } from "rebass";
import theme from "../../gatsby-plugin-theme-ui";

const BorderWrapper = ({ children, sx = {}, ...props }) => (
	<Flex
		bg="background"
		{...props}
		width={[null, null, `calc(100% + 2 * ${theme.space[3]}px)`]}
		height={[null, null, `calc(100% + 2 * ${theme.space[3]}px)`]}
		sx={{
			...sx,
			position: [null, null, 'relative'],
			top: [null, null, -3],
			left: [null, null, 0],
		}}
		p={[null, null, 3]}
	>
		{children}
	</Flex>
);

export default BorderWrapper